import React, { useEffect, useState } from "react";
import { Modal, Container, Row, Col } from "react-bootstrap";
import { Button } from "@mui/material";

// Legend Definitions
const legendData = [
  { code: "P", label: "Present", className: "present" },
  { code: "A", label: "Absent", className: "absent" },
  { code: "O", label: "Off Day", className: "offday" },
  { code: "R", label: "Rest Day", className: "restday" },
  { code: "PL", label: "Paid Leave", className: "leave" },
  { code: "UL", label: "Unpaid Leave", className: "unpaid_leave" },
  { code: "H", label: "Holiday", className: "holiday" },
  { code: "?", label: "Before Joining", className: "before-joining" },
];

// Optional gradients for attendance card display
const statusGradients = {
  A: "linear-gradient(135deg, #f8d7da 0%, #fbe9eb 100%)",
  O: "linear-gradient(135deg, #f1f8e9 0%, #f3f9ec 100%)",
  R: "linear-gradient(135deg, #e0f7fa 0%, #e9f9fb 100%)",
  L: "linear-gradient(135deg, #e38582 0%, #f1c2c1 100%)",
  E: "linear-gradient(135deg, #ffd699 0%, #ffebcc 100%)",
  P: "linear-gradient(135deg, #d4edda 0%, #dbf0e0 100%)",
  "?": "linear-gradient(135deg, #eeeeee 0%, #f9f9f9 100%)",
  default: "#f5f5f5",
};

// Convert to YYYY-MM-DD in local timezone
const getLocalDateISO = (date) => {
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 10);
};

const PayrollView = ({ show, handleClose, payroll }) => {
  const [statusMap, setStatusMap] = useState({});
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    if (!payroll || !payroll.daily_status) return;

    const map = {};
    payroll.daily_status.forEach((entry) => {
      const code = entry.status === null ? null : entry.status;
      let detail = "No Record";

      switch (code) {
        case "A": detail = "Absent"; break;
        case "P": detail = "Present"; break;
        case "L": detail = "Paid Leave"; break;
        case "UL": detail = "Unpaid Leave"; break;
        case "O": detail = "Off Day"; break;
        case "R": detail = "Rest Day"; break;
        case "H": detail = "Holiday"; break;
        case "OD": detail = "On Duty"; break;
        case "D": detail = "Deduction"; break;
        case "E": detail = "Early Logout"; break;
        case "OT": detail = "Overtime"; break;
        default: detail = "No Record";
      }

      map[entry.date] = { code, detail };
    });

    setStatusMap(map);
  }, [payroll]);

  const getMonthName = (date) =>
    date.toLocaleString("default", { month: "long", year: "numeric" });

  const daysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();

  const getFirstDayOfMonth = (month, year) =>
    new Date(year, month, 1).getDay();

  const handlePrevMonth = () => {
    if (selectedMonth === 1) {
      setSelectedMonth(12);
      setSelectedYear((prev) => prev - 1);
    } else {
      setSelectedMonth((prev) => prev - 1);
    }
    setCurrentDate(new Date(selectedYear, selectedMonth - 2));
  };

  const handleNextMonth = () => {
    if (selectedMonth === 12) {
      setSelectedMonth(1);
      setSelectedYear((prev) => prev + 1);
    } else {
      setSelectedMonth((prev) => prev + 1);
    }
    setCurrentDate(new Date(selectedYear, selectedMonth));
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>
          {payroll?.employee_name}
          <span style={{ fontSize: "1rem", color: "grey" }}>
            {" "}({payroll?.employee_id})
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="fixed-modal-body">
        {payroll && (
          <Container>
            <Row className="mt-1">
               <div className="card p-3">
                <h5 className="mb-2">Salary Details</h5>
                <hr />
                <Row>
                <Col md={3}>
                    <div><strong>Basic Salary:</strong> ₹{payroll.salary?.basic_salary || 0}</div>
                </Col>
                <Col md={3}>
                    <div><strong>Deductions:</strong> ₹{payroll.salary?.total_deductions_amount || 0}</div>
                </Col>
                <Col md={3}>
                    <div><strong>Alowances:</strong> ₹{payroll.salary?.allowances || 0}</div>
                </Col>
                <Col md={3}>
                    <div><strong>Bonus:</strong> ₹{payroll.salary?.bonus|| 0}</div>
                </Col>
                </Row>
                <Row className="mt-2">
                <Col md={3}>
                    <div><strong>HRA:</strong> ₹{payroll.salary?.hra || "NA"}</div>
                </Col>
                <Col md={3}>
                    <div><strong>Gross Salary:</strong> ₹{payroll.salary?.gross_salary || 0}</div>
                </Col>
                <Col md={3}>
                    <div><strong>Net Salary:</strong> ₹{payroll.salary?.net_salary || 0}</div>
                </Col>
                
                <Col md={3}>
                    <div><strong>Present Days:</strong> {payroll.salary?.present_days || 0}</div>
                </Col>
                </Row>
                <Row className="mt-2">
                <Col md={3}>
                    <div><strong>Total Working Days:</strong> {payroll.salary?.total_working_days|| 0}</div>
                </Col>
                <Col md={3}>
                    <div><strong>Absent Days:</strong> {payroll.salary?.absent_days || 0}</div>
                </Col>
                <Col md={3}>
                    <div><strong>Unpaid Leaves:</strong> {payroll.salary?.unpaid_leaves || 0}</div>
                </Col>
                
                <Col md={3}>
                    <div><strong>Payable Days:</strong> {payroll.salary?.payable_days || 0}</div>
                </Col>
                </Row>
            </div>
            </Row>
            <Row>
              <Col>
            <div className="calendar-container card mt-1 p-3">
                <div className="d-flex justify-content-center align-items-center mb-2">
                <h5 className="mb-0">
                {getMonthName(new Date(payroll?.effective_from_date))}{" "}
                {/* {new Date(payroll?.effective_from_date).getFullYear()} */}
                </h5>

                </div>
                <div className="calendar-grid">
                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                    <div className="calendar-header" key={day}>{day}</div>
                ))}
                {Array(getFirstDayOfMonth(
                    new Date(payroll?.effective_from_date).getMonth(),
                    new Date(payroll?.effective_from_date).getFullYear()
                )).fill(null).map((_, i) => (
                    <div key={`empty-${i}`} className="calendar-cell empty" />
                ))}
                {Array(daysInMonth(
                    new Date(payroll?.effective_from_date).getMonth(),
                    new Date(payroll?.effective_from_date).getFullYear()
                )).fill(null).map((_, i) => {
                    const date = i + 1;
                    const fullDate = getLocalDateISO(new Date(
                    new Date(payroll?.effective_from_date).getFullYear(),
                    new Date(payroll?.effective_from_date).getMonth(),
                    date
                    ));
                    const tileDate = new Date(
                    new Date(payroll?.effective_from_date).getFullYear(),
                    new Date(payroll?.effective_from_date).getMonth(),
                    date
                    );
                    const effectiveFrom = new Date(payroll?.effective_from_date);

                    let status = statusMap[fullDate];
                    let code = status?.code || "";

                    if (!status && tileDate < effectiveFrom) {
                    code = "?";
                    status = { code: "?", detail: "Before Joining" };
                    }

                    const legendClass =
                    legendData.find((l) => l.code === code)?.className ||
                    (code === "?" ? "before-joining" : "");

                    return (
                    <div
                        key={date}
                        className={`calendar-cell ${legendClass}`}
                        onClick={() =>
                        setSelectedDate(
                            new Date(
                            new Date(payroll?.effective_from_date).getFullYear(),
                            new Date(payroll?.effective_from_date).getMonth(),
                            date
                            )
                        )
                        }
                    >
                        <div className="date-number">{date}</div>
                        <span
                        className={`symbol ${legendClass}`}
                        style={{ fontSize: "0.7rem" }}
                        >
                        {code}
                        </span>
                    </div>
                    );
                })}
                </div>
            </div>
            </Col>


              <Col>
                <Row >
                <div
                    className="attendance-card mt-1 p-3"
                    style={{
                    background:
                        statusGradients[
                        statusMap[getLocalDateISO(selectedDate)]?.code
                        ] || statusGradients.default,
                    borderRadius: "10px",
                    }}
                >
                    <Row className="align-items-center">
                    <Col xs={3} style={{ textAlign: "left" }}>
                    <div className="date-section">
                        <div
                        className="date"
                        style={{ fontSize: "1.2rem", fontWeight: "bold" }}
                        >
                        {new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1).getDate()} <br />
                        <span
                            className="weekday"
                            style={{ fontSize: "1.1rem", color: "#555" }}
                        >
                            {new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1).toLocaleString("en-us", { weekday: "short" })}
                        </span>
                        </div>
                    </div>
                    </Col>

                   <Col
                    xs={9}
                    className="d-flex align-items-center"
                    style={{ fontSize: "1.5rem", fontWeight: "bold", textAlign: "left" }}
                    >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {(() => {
                        const code = statusMap[getLocalDateISO(selectedDate)]?.code;
                        switch (code) {
                            case "R":
                            return "Rest Day";
                            case "O":
                            return "Off Day";
                            case "A":
                            return "Absent";
                            case "P":
                            return "Present";
                            case "UL":
                            return "Unpaid Leave";
                            case "PL":
                            return "Paid Leave";
                            default:
                            return "No Attendance Record";
                        }
                        })()}
                    </div>
                    </Col>

                    </Row>
                </div>
                </Row>
                <Row>
                  <div className="legend-container card p-3 mt-4">
                    <h5 className="mb-3">Legends</h5>
                    <div className="legend-grid">
                      {legendData.map((item, index) => (
                        <div className="legend-item" key={index}>
                          <span
                            className={`legend-symbol ${item.className}`}
                          >
                            {item.code}
                          </span>
                          <span className="legend-label">{item.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </Row>
              </Col>
            </Row>
          </Container>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PayrollView;















// <Row>
//                   <div className="header single-row mt-4">
//                     <Row>
//                       <Col xs={4}>
//                         <div className="date-section">
//                           <div className="date">
//                             {selectedDate.getDate()} <br />
//                             <span className="weekday">
//                               {selectedDate.toLocaleString("en-us", {
//                                 weekday: "short",
//                               })}
//                             </span>
//                           </div>
//                         </div>
//                       </Col>
//                       <Col xs={8}>
//                         <div className="scheme-section mt-2">
//                           <div className="scheme">General</div>
//                           <div className="scheme-type">Attendance Scheme</div>
//                         </div>
//                       </Col>
//                     </Row>
//                   </div>
//                 </Row>